import { endpointStatistic } from './base.config';

export const integration = {
  getIntegrationOverviewList: `${endpointStatistic}/integration/overview`,
  getIntegrationVoucherStats: `${endpointStatistic}/integration/voucher/stats`,
  getCompanyVouchersByService: (companyId, service) =>
    `${endpointStatistic}/integration/voucher/${companyId}/${service}`,
};
